"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestService = void 0;
const axios_1 = __importStar(require("axios"));
const p_retry_1 = __importStar(require("p-retry"));
const Common_1 = require("./Common");
const Logger_1 = __importDefault(require("./Logger"));
const RETRY_OPTIONS = {
    retries: Common_1.RETRY_COUNT,
    minTimeout: Common_1.BASE_DELAY,
    factor: 2,
};
const REQUEST_TIMEOUT = 2000;
class RestService {
    constructor(contextService) {
        this.contextService = contextService;
        this.axios = axios_1.default.create({
            timeout: REQUEST_TIMEOUT,
            adapter: "fetch",
        });
    }
    doGetWhitelist(whitelistUrl, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            Logger_1.default.debug("REST API GET Filtering file", whitelistUrl);
            return this.axios.get(whitelistUrl, { headers });
        });
    }
    userConsentUrl(locale, user) {
        return [Common_1.SERVERS[this.contextService.context.config.env].userConsent, locale, user].filter((e) => e).join("/");
    }
    doGetNamedUserConsent(tokenInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.doGetUserConsent(tokenInfo);
        });
    }
    doGetUnnamedUserConsent() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.doGetUserConsent();
        });
    }
    doGetUserConsent(tokenInfo) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const locale = (_b = (_a = this.contextService.context.facets.product.locale) !== null && _a !== void 0 ? _a : window.navigator.language) !== null && _b !== void 0 ? _b : "en";
                return yield this.doGetUserConsentWithLocale(locale, tokenInfo);
            }
            catch (e) {
                if (e instanceof axios_1.AxiosError && ((_c = e.response) === null || _c === void 0 ? void 0 : _c.status) === 404) {
                    return yield this.doGetUserConsentWithLocale("en", tokenInfo);
                }
                throw e;
            }
        });
    }
    doGetUserConsentWithLocale(locale, tokenInfo) {
        return (0, p_retry_1.default)(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const url = this.userConsentUrl(locale, tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.userId);
                const config = tokenInfo ? { headers: { Authorization: `Bearer ${tokenInfo.userToken}` } } : undefined;
                Logger_1.default.debug("REST API GET User consent", url);
                return yield this.axios.get(url, config);
            }
            catch (e) {
                if (e instanceof axios_1.AxiosError && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.status)) {
                    throw new p_retry_1.AbortError(e);
                }
                throw e;
            }
        }), RETRY_OPTIONS);
    }
    doPostUserConsent(input, tokenInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.userConsentUrl();
            const data = { userId: tokenInfo.userId, preferences: input };
            const config = {
                headers: { Authorization: `Bearer ${tokenInfo.userToken}` },
            };
            Logger_1.default.debug("REST API POST User consent", url, data);
            return this.axios.post(url, data, config);
        });
    }
    sendEvent(data, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const retryAbortController = new AbortController();
            return (0, p_retry_1.default)(() => __awaiter(this, void 0, void 0, function* () {
                const url = Common_1.SERVERS[this.contextService.context.config.env].analytics;
                const config = {
                    headers: { "Content-Type": "application/json; charset=utf-8" },
                    fetchOptions: {
                        keepalive: true,
                    },
                };
                Logger_1.default.debug("REST API POST User consent", url, data.type, data.scope, data.facets);
                return this.axios.post(url, data, config);
            }), Object.assign(Object.assign({}, RETRY_OPTIONS), { onFailedAttempt(error) {
                    var _a;
                    callback === null || callback === void 0 ? void 0 : callback(error);
                    if (error instanceof axios_1.AxiosError && (error.status || ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status))) {
                        throw new p_retry_1.AbortError(error.message);
                    }
                }, signal: retryAbortController.signal }));
        });
    }
}
exports.RestService = RestService;
